import React, { useState } from 'react';
import Chart from "react-apexcharts";
import { PostApiMethod } from "../../core/services/apiService";
import 'react-datepicker/dist/react-datepicker.css';
import './apexChart.css';
import { dashboardChartProps } from '../../core/dto/dashboard.dto';

const IncomingCallBreakdownChart = ({ apiEndpoint, startDate, endDate, selectedLocation, selectedAgent, selectedCallDirection, onChartLoaded }: dashboardChartProps) => {
  const [incomingCallBreakdownChartDetail, setIncomingCallBreakdownChartDetail,] = React.useState<any>({ labels: [], datasets: [] });
  const [loaded, setLoaded] = React.useState(false);


  React.useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const alternatingColors = ['#439a43', '#0187C4'];
        const payload = {
          from_date: startDate ? startDate.toLocaleDateString("en-CA") : null,
          to_date: endDate ? endDate.toLocaleDateString("en-CA") : null,
          call_flow: selectedCallDirection ? selectedCallDirection : "",
          agent_id: selectedAgent ? selectedAgent : "",
          location_id: selectedLocation ? selectedLocation : "",
          clientTZ: Intl.DateTimeFormat().resolvedOptions().timeZone
        };

        const response = await PostApiMethod(apiEndpoint, payload);
        const labels: string[] = [];
        const data: number[] = [];

        response?.data?.data?.forEach((element: any) => {
          const label = capitalizeFirstLetter(element.label);
          const count = element?.count;
          labels.push(label);
          data.push(count);
        });

        let count = data?.reduce((sum, val) => sum + val, 0);
        let options: any = {
          chart: { id: 'breakdown-chart' },
          plotOptions: {
            bar: {
              distributed: true,
              dataLabels: { position: "top" }
            }
          },
          legend: { show: false },
          colors: data?.map((_, i) => alternatingColors[i % alternatingColors.length]),
          xaxis: {
            categories: labels,
            labels: {
              trim: false,
              rotateAlways: true,
              rotate: -45,
              style: { fontSize: "14px" }
            }
          },
          grid: { padding: { bottom: 20 } },
          yaxis: {
            labels: {
              show: true,
              style: { fontSize: '14px' }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (val: number, opts: any) {
              const total = opts?.w && opts.w.globals?.seriesTotals?.reduce((a: number, b: number) => a + b, 0);
              const percent = ((val / total) * 100).toFixed(1);
              return `${val} (${percent}%)`;
            },
            dropShadow: { enabled: false },
            style: {
              colors: ['#4d4d4d'],
              fontSize: '15px',
              fontWeight: "normal"
            },
            offsetY: -20
          }
        };

        let series = [{ name: '', data: data }];
        let chartData = { labels: options, series: series, count: count }
        if (isMounted) {
          setIncomingCallBreakdownChartDetail(chartData);
          if (!loaded) {
            onChartLoaded?.();
            setLoaded(true);
          }
        }
      } catch (err) {
        console.error('Error fetching reports:', err);
      }
    })();
    return () => { isMounted = false };
  }, [apiEndpoint, startDate, endDate, selectedCallDirection, selectedLocation, selectedAgent]);

  const incomingCallBreakdownChartData = React.useMemo(() =>
    incomingCallBreakdownChartDetail,
    [incomingCallBreakdownChartDetail]);


  const capitalizeFirstLetter = (string: string) => {
    return string[0]?.toUpperCase() + string?.slice(1);
  }

  return (
    <div className="overflow-hidden">
      <div className="row mb-3 chart-header" style={{ borderBottom: '2px solid #ddd', paddingBottom: '10px' }}> {/* Bottom Border */}
        <div className="col-12"><h5 className="text-center">Calls by Source</h5></div>
      </div>
      <div className="col-12">
        {incomingCallBreakdownChartData && incomingCallBreakdownChartData.count > 0 ? (
          <Chart
            options={incomingCallBreakdownChartData.labels}
            series={incomingCallBreakdownChartData.series}
            type="bar"
            height={380}

          />
        ) : (
          <div className="text-center py-4">No Records Found</div>
        )}
      </div>
    </div>
  );
};

export default IncomingCallBreakdownChart